import { render, staticRenderFns } from "./SectionBackgroundImage.vue?vue&type=template&id=38763cfa&"
import script from "./SectionBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./SectionBackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./SectionBackgroundImage.vue?vue&type=style&index=0&id=38763cfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
